import { getPostHog, isPostHogEnabled } from '@/lib/posthog';

export function capturePostHogPageview(pathname: string, search: string, title?: string | null) {
    if (!isPostHogEnabled()) {
        return;
    }

    getPostHog().capture('$pageview', {
        $current_url: `${window.location.origin}${pathname}${search}`,
        pathname,
        search,
        title: title ?? document.title
    });
}
